import * as React from 'react'
import LanguageIcon from '@mui/icons-material/Language'
import {Button} from '@mui/material'
import Box from '@mui/material/Box'

import {toggleLang} from 'src/redux'
import {useAppDispatch} from 'src/hooks'
import {useLocation, useNavigate} from 'react-router-dom'

const ChangeLang = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const changeLang = (lang: string) => {

  const pathname = location.pathname.slice(0, -2) + lang
    dispatch(toggleLang(lang))
    navigate({pathname: pathname, search: location.search, hash: location.hash})
    // setTimeout(() => {
    //   // location.reload()
    // }, 0)
  }

  return (
    <Box sx={{minWidth: 40, display: 'flex', alignItems: 'center'}}>
      <Button
        sx={{fontSize: '14px'}}
        onClick={() => changeLang('kg')}
        variant={'contained'}
        size={'small'}
        endIcon={<LanguageIcon />}
      >
        KG
      </Button>
      |
      <Button
        onClick={() => changeLang('ru')}
        sx={{fontSize: '14px'}}
        variant={'contained'}
        size={'small'}
        endIcon={<LanguageIcon />}
      >
        RU
      </Button>
    </Box>
  )
}

export default ChangeLang
